import { Box } from "@mui/material";
import { BoxProps } from "@mui/system";
import { FunctionComponent } from "react";

const Spacer: FunctionComponent<BoxProps> = ({ ...boxProps }) => {
  return <Box sx={{ flexGrow: 1 }} {...boxProps} />;
};

export default Spacer;
